// import React, { useEffect, useState } from 'react';
// import { Modal, Button, Form } from 'react-bootstrap';
// import Navbar from '../../Components/Navbar';
// import Table from 'react-bootstrap/Table';
// import axios from 'axios';
// import '../Secretary/Table.css';
// import { API_BASE_URL } from '../../config';
// export default function ShortlistedApplication() {
//   const [submittedGrants, setSubmittedGrants] = useState([]);
//   const [showStatusModal, setShowStatusModal] = useState(false);
//   const [showGrantModal, setShowGrantModal] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedGrant, setSelectedGrant] = useState(null);
//   const [startDate, setStartDate] = useState('');
//   const [period, setPeriod] = useState('');
//   const [amount, setAmount] = useState('');
//   const [decision, setDecision] = useState(null);
//   const [uploading, setUploading] = useState(false);
//   const [selectedFile, setSelectedFile] = useState(null);

//   // Fetch data on component mount
//   useEffect(() => {
//     const fetchSubmittedGrants = async () => {
//       try {
//         const response = await axios.get(`${API_BASE_URL}/ApprovedApplications.php`);
//         setSubmittedGrants(Array.isArray(response.data) ? response.data : []);
//       } catch (error) {
//         console.error('Error fetching data:', error);
//       }
//     };

//     fetchSubmittedGrants();
//   }, []);

//   // Open the modal with the decision options
//   const handleShowStatusModal = (grant) => {
//     setSelectedGrant(grant);
//     setShowStatusModal(true);
//   };

//   // Close the first modal
//   const handleCloseStatusModal = () => {
//     setShowStatusModal(false);
//     setDecision(null);
//   };

//   // Show the second modal (Start Date and Period input)
//   const handleGrantedClick = () => {
//     setShowStatusModal(false);
//     setShowGrantModal(true);
//     setDecision('Granted');
//   };

//   // Handle Deny click
//   const handleDenyClick = async () => {
//     setShowStatusModal(false);
//     await updateStatus('5.2'); // Denied status
//   };

//   const handleGrant = async () => {
//     if (!selectedGrant) return;

//     try {
//       // Update the application status to "Granted"
//       await updateStatus('5.1');

//       // Prepare email details
//       const emailData = {
//         email: selectedGrant.email,
//         subject: 'Application Granted for Funding',
//         message: `
//           Dear ${selectedGrant.name},<br><br>
//           We are pleased to inform you that your application titled <b>${selectedGrant.projectTitle}</b>
//           has been approved for funding<br>
//           <b>Start Date:</b> ${startDate}<br>
//           <b>Period:</b> ${period}<br>
//           <b>Approved Amount:</b> LKR ${amount}<br><br>
//           Please log in to the grant management system at https://rgms.pdn.ac.lk/. Navigate to Application Details > More details > Award Letter to download the agreement. Once the Principal Investigator (PI) and Co-Investigators (Co-Is) have signed the agreement, please upload it to the portal.
//           Best regards,<br>
//           University of Peradeniya.
//         `,
//       };

//       // Send email
//       const emailResponse = await axios.post(`${API_BASE_URL}/Email.php`, emailData);

//       if (emailResponse.data.status === 'success') {
//         alert('Email notification sent to the applicant.');
//       } else {
//         alert(`Error sending email: ${emailResponse.data.message}`);
//       }

//       // Close modal
//       handleCloseGrantModal();
//     } catch (error) {
//       console.error('Error granting application or sending email:', error);
//     }
//   };

//   // Update the status of the application (Granted or Denied)
//   const updateStatus = async (status) => {
//     try {
//       await axios.post(`${API_BASE_URL}/ApplicationStatus_Granted.php`, {
//         appId: selectedGrant.Id,
//         status,
//         startDate,
//         period,
//         amount,
//       });

//       setSubmittedGrants((prevGrants) =>
//         prevGrants.map((grant) =>
//           grant.Id === selectedGrant.Id ? { ...grant, Status: status } : grant
//         )
//       );

//       handleCloseGrantModal();
//     } catch (error) {
//       console.error('Error updating status:', error);
//     }
//   };

//   const handleCloseGrantModal = () => {
//     setShowGrantModal(false);
//     setStartDate('');
//     setPeriod('');
//     setAmount('');
//     setSelectedGrant(null);
//   };

//   const handleFileChange = (event) => {
//     setSelectedFile(event.target.files[0]);
//   };

//   // const handleFileUpload = async () => {
//   //   if (!selectedFile) {
//   //     alert('Please select a file to upload.');
//   //     return;
//   //   }
  
//   //   setUploading(true);
//   //   const formData = new FormData();
//   //   formData.append('file', selectedFile);
//   //   formData.append('appId', selectedGrant.app_ID);
  
//   //   try {
//   //     const response = await axios.post('AwardLetter.php', formData, {
//   //       headers: { 'Content-Type': 'multipart/form-data' },
//   //     });
  
//   //     const result = response.data;
//   //     if (result.success) {
//   //       alert('File uploaded successfully!');
//   //     } else {
//   //       alert(result.message);
//   //     }
//   //   } catch (error) {
//   //     console.error('Error uploading file:', error);
//   //     alert('An error occurred while uploading the file.');
//   //   } finally {
//   //     setShowModal(false);
//   //     setUploading(false);
//   //     setSelectedFile(null);
//   //   }
//   // };
//   const handleFileUpload = async () => {
//     if (!selectedFile) {
//         alert('Please select a file to upload.');
//         return; // Don't proceed if no file is selected
//     }

//     setUploading(true); // Indicate that the upload is in progress
//     const formData = new FormData();
//     formData.append('file', selectedFile); // Attach the selected file
//     formData.append('app_ID', selectedGrant?.app_ID); // Use optional chaining to avoid errors

//     try {
//         const response = await axios.post(`${API_BASE_URL}/AwardLetter.php`, formData, {
//             headers: { 'Content-Type': 'multipart/form-data' }, // Important header for file uploads
//         });

//         const result = response.data;
//         if (result.success) {
//             alert('File uploaded successfully!');
//         } else {
//             alert(result.message); // Show error message if any
//         }
//     } catch (error) {
//         console.error('Error uploading file:', error);
//         alert('An error occurred while uploading the file.'); // Handle errors during the upload
//     } finally {
//         setShowModal(false); // Close the modal after upload
//         setUploading(false); // Stop uploading indication
//         setSelectedFile(null); // Clear the selected file
//     }
// };


//   const handleUploadClick = (grantId) => {
//     setSelectedGrant({ app_ID: grantId }); // Ensure the correct structure
//     setShowModal(true);
//   };

//   return (
//     <div>
//       <Navbar />
//       <h1 className="page-title">Approved Applications</h1>
//       <Table striped bordered hover style={{ marginTop: '20px', boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)' }}>
//         <thead>
//           <tr>
//             <th>Application Id</th>
//             <th>Project Title</th>
//             <th>Submitted Date</th>
//             <th>Reviewer 1</th>
//             <th>Reviewer 2</th>
//             <th>HOD</th>
//             <th>Dean</th>
//             <th>Status</th>
//             {/* <th>Award Letter</th> */}
//           </tr>
//         </thead>
//         <tbody>
//           {submittedGrants.length > 0 ? (
//             submittedGrants.map((grant, index) => (
//               <tr key={index}>
//                 <td>{grant.Id}</td>
//                 <td>{grant.projectTitle}</td>
//                 <td>{grant.submittedDate}</td>
//                 <td>{grant.reviewer1_mark || 'Not Rated'}</td>
//                 <td>{grant.reviewer2_mark || 'Not Rated'}</td>
//                 <td>{grant.hod_decision || 'Not Decided'}</td>
//                 <td>{grant.dean_decision || 'Not Decided'}</td>
//                 <td>
//                  {(grant.Status === '3.1'|| grant.Status === '2.1') && (
//                     <button className="select-unselect-button" onClick={() => handleShowStatusModal(grant)}>
//                       Select
//                     </button>
//                   )}
//                   {grant.Status === '5.1' && (
//                     <button className="granted-button" disabled>
//                       Granted
//                     </button>
//                   )}
//                   {grant.Status === '5.2' && (
//                     <button className="not-granted-button" disabled>
//                       Deny
//                     </button>
//                   )}
//                 </td>
//                 {/* <td>
//                   <button 
//                     className="uploadRequest_button"
//                     onClick={() => handleUploadClick(grant.Id)}
//                   >
//                     Upload
//                   </button>
//                 </td> */}
//               </tr>
//             ))
//           ) : (
//             <tr>
//               <td colSpan="8" style={{ textAlign: 'center' }}>
//                 No submitted grants found.
//               </td>
//             </tr>
//           )}
//         </tbody>
//       </Table>

//       {/* Status Selection Modal */}
//       <Modal show={showStatusModal} onHide={handleCloseStatusModal}>
//         <Modal.Header closeButton>
//           <Modal.Title className='modaltitle'>Select Status</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Button variant="success" className='granted_deny' onClick={handleGrantedClick}>
//             Granted
//           </Button>
//           <Button variant="danger" className='granted_deny' onClick={handleDenyClick}>
//             Deny
//           </Button>
//         </Modal.Body>
//       </Modal>

//       {/* Grant Details Modal */}
//       <Modal show={showGrantModal} onHide={handleCloseGrantModal}>
//         <Modal.Header closeButton>
//           <Modal.Title className='modaltitle'>Enter Grant Details</Modal.Title>
//         </Modal.Header>
//         <Modal.Body className='modal'>
//           <Form>
//             <Form.Group>
//               <Form.Label>Start Date</Form.Label>
//               <Form.Control
//                 type="date"
//                 value={startDate}
//                 onChange={(e) => setStartDate(e.target.value)}
//               />
//             </Form.Group>
//             <Form.Group>
//               <Form.Label>Period</Form.Label>
//               <Form.Control
//                 type="text"
//                 value={period}
//                 onChange={(e) => setPeriod(e.target.value)}
//                 placeholder='Ex: 2 Months / 2 Years'
//               />
//             </Form.Group>
//             <Form.Group>
//               <Form.Label>Approved Amount (LKR)</Form.Label>
//               <Form.Control
//                 type="text"
//                 value={amount}
//                 onChange={(e) => setAmount(e.target.value)}
//               />
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleCloseGrantModal}>
//             Cancel
//           </Button>
//           <Button variant="primary" className='Grant_Application' onClick={handleGrant}>
//             Grant Application
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* File Upload Modal */}
//       <Modal show={showModal} onHide={() => setShowModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Upload File</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <input type="file" onChange={handleFileChange} />
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowModal(false)}>
//             Close
//           </Button>
//           <Button 
//             variant="primary" 
//             onClick={handleFileUpload}
//             disabled={uploading}
//           >
//             {uploading ? 'Uploading...' : 'Upload'}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }


import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Navbar from "../../Components/Navbar";
import Table from "react-bootstrap/Table";
import axios from "axios";
import "../Secretary/Table.css";
import { API_BASE_URL } from "../../config";

export default function ShortlistedApplicationD() {
  const [submittedGrants, setSubmittedGrants] = useState([]);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [showGrantModal, setShowGrantModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedGrant, setSelectedGrant] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [period, setPeriod] = useState("");
  const [amount, setAmount] = useState("");
  const [decision, setDecision] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [filteredGrants, setFilteredGrants] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");

  const currentYear = new Date().getFullYear();
  const startYear = 2024; // Adjust as needed
  const years = Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => startYear + i
  ).reverse(); // Reverse to show latest years first

  useEffect(() => {
    const fetchSubmittedGrants = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/ApprovedApplications.php`
        );
        const grants = Array.isArray(response.data) ? response.data : [];
        setSubmittedGrants(grants);
        if (selectedYear === "") {
          setFilteredGrants(grants); // Show all grants
        } else {
          setFilteredGrants(
            grants.filter((grant) => {
              const grantYear = new Date(grant.submittedDate).getFullYear();
              return grantYear === parseInt(selectedYear);
            })
          );
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setSubmittedGrants([]);
        setFilteredGrants([]);
      }
    };

    fetchSubmittedGrants();
  }, [selectedYear]);

  // Open the modal with the decision options
  const handleShowStatusModal = (grant) => {
    setSelectedGrant(grant);
    setShowStatusModal(true);
  };

  // Close the first modal
  const handleCloseStatusModal = () => {
    setShowStatusModal(false);
    setDecision(null);
  };

  // Show the second modal (Start Date and Period input)
  const handleGrantedClick = () => {
    setShowStatusModal(false);
    setShowGrantModal(true);
    setDecision("Granted");
  };

  // // Handle Deny click
  // const handleDenyClick = async () => {
  //   setShowStatusModal(false);
  //   await updateStatus('5.2'); // Denied status
  // };
  const handleDenyClick = async () => {
    if (!selectedGrant) return;

    try {
      // Close the modal
      setShowStatusModal(false);

      // Update the application status to "Denied"
      await updateStatus("5.2");

      // Prepare email details
      const emailData = {
        email: selectedGrant.email,
        subject: "Application Rejection Notification",
        message: `
          Dear ${selectedGrant.name},<br><br>
          Thank you for submitting your application for the multidisciplinary research grants offered by
          the University Research Council. We greatly appreciate the time, effort, and dedication you
          invested in preparing your proposal.<br><br>
          This year’s competition was exceptionally strong, with a high volume of outstanding
          applications. The selection process was based on the quality of each application, its relative
          ranking among other submissions, and the available budget. Applications were evaluated by
          a panel of experts using a scoring scale from 0 to 100.<br><br>
          Regrettably, we must inform you that your application was not selected for funding. To assist
          you in strengthening future submissions, we have attached detailed feedback reports from
          two independent evaluators. We hope these insights will prove valuable as you refine your
          proposal.<br><br>
          We are grateful for your interest in our research grant program and encourage you to
          consider applying for future funding opportunities. The University Research Council remains
          committed to supporting innovative research and looks forward to the possibility of
          collaborating with you in the future.<br><br>
          Should you have any questions or require further clarification, please do not hesitate to
          contact us.<br><br>
          Thank you once again for your submission, and we wish you continued success in your
          research endeavours.<br><br>
          With best regards,<br>
          Director/URC.
        `,
      };

      // Send rejection email
      const emailResponse = await axios.post(
        `${API_BASE_URL}/Email.php`,
        emailData
      );

      if (emailResponse.data.status === "success") {
        alert("Rejection email notification sent to the applicant.");
      } else {
        alert(`Error sending email: ${emailResponse.data.message}`);
      }
    } catch (error) {
      console.error("Error denying application or sending email:", error);
    }
  };

  const handleGrant = async () => {
    if (!selectedGrant) return;

    try {
      // Update the application status to "Granted"
      await updateStatus("5.1");

      // Prepare email details
      const emailData = {
        email: selectedGrant.email,
        subject: "Application Granted for Funding",
        message: `
          Dear ${selectedGrant.name},<br><br>
          We are pleased to inform you that your application titled <b>${selectedGrant.projectTitle}</b>
          has been approved for funding.<br>
          <b>Start Date:</b> ${startDate}<br>
          <b>Period:</b> ${period}<br>
          <b>Approved Amount:</b> LKR ${amount}<br><br>
          Please log in to the grant management system at https://rgms.pdn.ac.lk/. Navigate to Application Details > More details > Award Letter to download the agreement. Once the Principal Investigator (PI) and Co-Investigators (Co-Is) have signed the agreement, please upload it to the portal.<br><br>
          Best regards,<br>
          University of Peradeniya.
        `,
      };

      // Send email
      const emailResponse = await axios.post(
        `${API_BASE_URL}/Email.php`,
        emailData
      );

      if (emailResponse.data.status === "success") {
        alert("Email notification sent to the applicant.");
      } else {
        alert(`Error sending email: ${emailResponse.data.message}`);
      }

      // Close modal
      handleCloseGrantModal();
    } catch (error) {
      console.error("Error granting application or sending email:", error);
    }
  };

  // Update the status of the application (Granted or Denied)
  const updateStatus = async (status) => {
    try {
      await axios.post(`${API_BASE_URL}/ApplicationStatus_Granted.php`, {
        appId: selectedGrant.Id,
        status,
        startDate,
        period,
        amount,
      });

      setSubmittedGrants((prevGrants) =>
        prevGrants.map((grant) =>
          grant.Id === selectedGrant.Id ? { ...grant, Status: status } : grant
        )
      );

      handleCloseGrantModal();
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const handleCloseGrantModal = () => {
    setShowGrantModal(false);
    setStartDate("");
    setPeriod("");
    setAmount("");
    setSelectedGrant(null);
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleFileUpload = async () => {
    if (!selectedFile) {
      alert("Please select a file to upload.");
      return; // Don't proceed if no file is selected
    }

    setUploading(true); // Indicate that the upload is in progress
    const formData = new FormData();
    formData.append("file", selectedFile); // Attach the selected file
    formData.append("app_ID", selectedGrant?.app_ID); // Use optional chaining to avoid errors

    try {
      const response = await axios.post(
        `${API_BASE_URL}/AwardLetter.php`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" }, // Important header for file uploads
        }
      );

      const result = response.data;
      if (result.success) {
        alert("File uploaded successfully!");
      } else {
        alert(result.message); // Show error message if any
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      alert("An error occurred while uploading the file."); // Handle errors during the upload
    } finally {
      setShowModal(false); // Close the modal after upload
      setUploading(false); // Stop uploading indication
      setSelectedFile(null); // Clear the selected file
    }
  };

  return (
    <div>
      <Navbar />
      <h1 className="page-title">Approved Applications</h1>
      <div className="year-filter">
        <label htmlFor="year-select">Year: </label>
        <select
          id="year-select"
          value={selectedYear}
          onChange={(e) => setSelectedYear(e.target.value)}
          className="year-select"
        >
          <option value="">Select Year</option>
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>
      <Table
        striped
        bordered
        hover
        style={{
          marginTop: "20px",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
        }}
      >
        <thead>
          <tr>
            <th>Application Id</th>
            <th>Project Title</th>
            <th>Submitted Date</th>
            <th>Reviewer 1</th>
            <th>Reviewer 2</th>
            <th>HOD</th>
            <th>Dean</th>
            <th>Status</th>
            {/* <th>Award Letter</th> */}
          </tr>
        </thead>
        <tbody>
          {filteredGrants.length > 0 ? (
            filteredGrants.map((grant, index) => (
              <tr key={index}>
                <td>{`${grant.Id}_${new Date().getFullYear()}`}</td>
                <td>{grant.projectTitle}</td>
                <td>{grant.submittedDate}</td>
                <td>{grant.reviewer1_mark || "Not Rated"}</td>
                <td>{grant.reviewer2_mark || "Not Rated"}</td>
                <td>{grant.hod_decision || "Not Decided"}</td>
                <td>{grant.dean_decision || "Not Decided"}</td>
                <td>
                  {(grant.Status === "3.1" || grant.Status === "2.1") && (
                    <button
                      className="select-unselect-button"
                      onClick={() => handleShowStatusModal(grant)}
                    >
                      Select
                    </button>
                  )}
                  {grant.Status === "5.1" && (
                    <button className="granted-button" disabled>
                      Granted
                    </button>
                  )}
                  {grant.Status === "5.2" && (
                    <button className="not-granted-button" disabled>
                      Deny
                    </button>
                  )}
                </td>
                {/* <td>
                  <button 
                    className="uploadRequest_button"
                    onClick={() => handleUploadClick(grant.Id)}
                  >
                    Upload
                  </button>
                </td> */}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" style={{ textAlign: "center" }}>
                No submitted grants found.
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      {/* Status Selection Modal */}
      <Modal show={showStatusModal} onHide={handleCloseStatusModal}>
        <Modal.Header closeButton>
          <Modal.Title className="modaltitle">Select Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Button
            variant="success"
            className="granted_deny"
            onClick={handleGrantedClick}
          >
            Granted
          </Button>
          <Button
            variant="danger"
            className="granted_deny"
            onClick={handleDenyClick}
          >
            Deny
          </Button>
        </Modal.Body>
      </Modal>

      {/* Grant Details Modal */}
      <Modal show={showGrantModal} onHide={handleCloseGrantModal}>
        <Modal.Header closeButton>
          <Modal.Title className="modaltitle">Enter Grant Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal">
          <Form>
            <Form.Group>
              <Form.Label>Start Date</Form.Label>
              <Form.Control
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Period</Form.Label>
              <Form.Control
                type="text"
                value={period}
                onChange={(e) => setPeriod(e.target.value)}
                placeholder="Ex: 2 Months / 2 Years"
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Approved Amount (LKR)</Form.Label>
              <Form.Control
                type="text"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseGrantModal}>
            Cancel
          </Button>
          <Button
            variant="primary"
            className="Grant_Application"
            onClick={handleGrant}
          >
            Grant Application
          </Button>
        </Modal.Footer>
      </Modal>

      {/* File Upload Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Upload File</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input type="file" onChange={handleFileChange} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={handleFileUpload}
            disabled={uploading}
          >
            {uploading ? "Uploading..." : "Upload"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
